import { FC } from "react";
import { useSnapshot } from "valtio";
import { mapStore } from "src/js/stores/map/store";
import { useMapLayer } from "react-migration/lib/map/useMapLayer";
import { LayerTypeMapLayerProps } from "../../../types";
import { PlanningApplicationClusteredViewportSearchMapLayer } from "./PlanningApplicationClusteredViewportSearchMapLayer";
import { usePlanningApplicationsContext } from "../PlanningApplicationsProvider";

export const PlanningApplicationsMapLayer: FC<LayerTypeMapLayerProps> = ({
  visible,
  zOrder,
  layer,
  detailSelection,
}) => {
  const { state } = usePlanningApplicationsContext();
  const { googleMap } = useSnapshot(mapStore);
  const { mapType } = useSnapshot(mapStore.settings);
  const shouldRenderLayer = visible && !detailSelection;

  useMapLayer(
    () => ({
      zOrder,
      layer: new PlanningApplicationClusteredViewportSearchMapLayer({
        id: "clustered-planning-layer",
        visible: shouldRenderLayer,
        googleMap,
        filters: state,
        showBoundaries: state.showBoundaries,
        mapType,
        clusterEventProperties: {
          selectionLayerId: layer.id,
        },
      }),
      visible: shouldRenderLayer,
    }),
    [zOrder, state, googleMap, mapType, layer.id, shouldRenderLayer]
  );

  return null;
};
